import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

/* Naimportuje všechny Bootstrapí pluginy */
//import BootstrapVue from 'bootstrap-vue'
//Vue.use(BootstrapVue)

/* Import jednotlivých pluginů, které potřebuji */
import { AlertPlugin } from 'bootstrap-vue'
Vue.use(AlertPlugin)

import { CollapsePlugin } from 'bootstrap-vue'
Vue.use(CollapsePlugin)

import { ButtonPlugin } from 'bootstrap-vue'
Vue.use(ButtonPlugin)

import './assets/scss/main.scss'

import axios from 'axios'

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {duration: 300});


/* Globální registrace komponent */

import { VueMathjax } from "vue-mathjax"
Vue.component('vue-mathjax', VueMathjax)

// Kvůli tomu, aby se vue komponenty obsažené ve stringu správně vykreslily
import VRuntimeTemplate from "v-runtime-template"
Vue.component('v-runtime-template', VRuntimeTemplate)


Vue.mixin({
methods: {

	/* Funkce na náhodné promíchání pole */
	shuffle(array) {
	var currentIndex = array.length, temporaryValue, randomIndex;
	
	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
	
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
	
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
	},

	prepareChoicesForMultipleAndSingleChoices() {
			// Rozparsování
			let parsedAnswer = this.parseChoices(this.question.answer);

			let correctChoicesArray = this.question.correct_choices.split(",");
			let choiceObject = { text: "", value: "", isCorrect: false };
			let id = "";

			parsedAnswer.querySelectorAll("li").forEach((item, i) => {
				id = i + 1;

				choiceObject.text = this.findAndRenderLaTeX(item.innerHTML);
				choiceObject.value = "choice-" + id;
				choiceObject.isCorrect = correctChoicesArray.includes(
					id.toString()
				);
				choiceObject.disabled = false;
				this.choices.push(JSON.parse(JSON.stringify(choiceObject)));
			});
	},
	
	disableMultipleAndSingleChoices() {
			this.choices.forEach((choice, index) => {
				this.choices[index].disabled = true;
			});
		},

	parseChoices(htmlStringWithChoices) {
	let parser = new DOMParser();
			let parsedAnswer = parser.parseFromString(
				htmlStringWithChoices,
				"text/html"
	);
	return parsedAnswer;
	},

	inflection(number, [first, secondThirdFourth, others], includeNumber = true) {
		let numberString = '';
		if (includeNumber) {
			numberString = number + ' ';
		}

		switch (number) {
			case 1:
				return numberString + first;
			case 2:
			case 3:
			case 4:
				return numberString + secondThirdFourth;
			default:
				return numberString + others;
		}
	},

	findAndRenderLaTeX(text) {
		const regex = /\\\[(.*?)\\\]/g;

		if (text !== null) {
			let allLatexGroups = [...text.matchAll(regex)];

			if (allLatexGroups) {
				allLatexGroups.forEach(latexGroup => {
					let latexElement = '<vue-mathjax formula="$$' + latexGroup[1] + '$$" />';

					text = text.replace(latexGroup[0], latexElement);
				});
			}
		}

		return '<div>' + text + '</div>';
	}

}
})

Vue.config.productionTip = false

const appElement = document.getElementById('testModule');

new Vue({
router,
store,
axios,
render: createElement => {
	const context = {
	props: { ...appElement.dataset },
	};
	return createElement(App, context);
}
}).$mount('#testModule')
